// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-floating-promises, react-hooks/exhaustive-deps */

import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Segment, Grid, Form } from "semantic-ui-react";
import { DateTimePicker } from "react-widgets";
import { toast } from "react-toastify";
import _ from "lodash";

import ProtocolSearch from "./protocolSearch";
import TrialSearch from "./trialSearch";

import { useAuth0 } from "../../../auth/auth0";
import { useUserAuth } from "../../../hooks/useUserAuth";

import * as trialActions from "../../../redux/actions/trialActions";
import * as protocolActions from "../../../redux/actions/protocolActions";
import * as growingSeasonActions from "../../../redux/actions/growingSeasonActions";

import filterResults from "./resultFilter";
import PropTypes from "prop-types";
import { ApplicationArea } from "../../Lumber/ApplicationAreas";

import "./style.css";

const Dashboard = ({ mode = "all", updateMapboxTrials, children }) => {
	const dispatch = useDispatch();
	const { getTokenSilently } = useAuth0();
	const userAuth = useUserAuth();
	const clientId = useSelector((state) => (state.clients ? state.clients.currentId : null));

	// #region UseStates

	// #region UI Control
	const [unlinkedProtocolDataLoading, setUnlinkedProtocolDataLoading] = useState(true);
	const [linkingProtocolsLoading, setLinkingProtcolsLoading] = useState(true);
	const [unlinkedTrialDataLoading, setUnlinkedTrialDataLoading] = useState(true);
	const [linkingTrialsLoading, setLinkingTrialsLoading] = useState(true);
	const [protocolFilterLoading, setProtocolFilterLoading] = useState(true);
	const [trialFilterLoading, setTrialFilterLoading] = useState(true);
	const [resetFields, setResetFields] = useState(true);
	const [selectedTimeRange, setSelectedTimeRange] = useState("thisYear");
	// #endregion

	// #region Data
	const [unlinkedProtocolData, setUnlinkedProtocolData] = useState(null);
	const [linkedProtocolData, setLinkedProtocolData] = useState(null);
	const [filteredProtocolData, setFilteredProtocolData] = useState([]);
	const [unlinkedTrialData, setUnlinkedTrialData] = useState(null);
	const [linkedTrialData, setLinkedTrialData] = useState(null);
	const [filteredTrialData, setFilteredTrialData] = useState([]);
	const [trialStatuses, setTrialStatuses] = useState([]);
	const [timeRangeStart, setTimeRangeStart] = useState(null);
	const [timeRangeEnd, setTimeRangeEnd] = useState(null);
	const [timeRangeDirty, setTimeRangeDirty] = useState(false);
	// #endregion

	// #region Search Options

	// #region General
	// const [productCategory, setProductCategory] = useState(null);
	const [crop, setCrop] = useState("All");
	const [growingSeason, setGrowingSeason] = useState(null);
	const [variableTested, setVariableTested] = useState("All");
	const [timeRanges, setTimeRanges] = useState([]);
	const [growingSeasonOptions, setGrowingSeasonOptions] = useState([]);
	const [growingSeasons, setGrowingSeasons] = useState([]);
	// #endregion

	// #region Protocol Specific
	const [protocolName, setProtocolName] = useState(null);
	const [protocolOwner, setProtocolOwner] = useState(null);
	// #endregion

	// #region Trial Specific
	const [trialName, setTrialName] = useState(null);
	const [trialOwner, setTrialOwner] = useState(null);
	const [cooperator, setCooperator] = useState(null);
	const [city, setCity] = useState(null);
	const [region, setRegion] = useState(null);
	const [country, setCountry] = useState(null);
	const [company, setCompany] = useState(null);
	const [defStatus, setDefStatus] = useState(null);
	// #endregion

	// #endregion

	// #endregion

	// #region Time Range Setup
	const today = new Date();
	const lastWeek = new Date();
	const lastDayOfThisMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
	const lastDayOfLastMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 0).getDate();
	const yearOfLastMonth = new Date().getFullYear() - (new Date().getMonth() === 1 ? 1 : 0);
	const timeRangePresetLookup = [
		{
			id: "noDate",
			value: {
				plantDateFrom: null,
				plantDateTo: null,
			},
		},
		{
			id: "thisWeek",
			value: {
				plantDateFrom: new Date(today.setDate(new Date().getDate() - new Date().getDay())),
				plantDateTo: new Date(today.setDate(new Date().getDate() - new Date().getDay() + 6)),
			},
		},
		{
			id: "thisMonth",
			value: {
				plantDateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
				plantDateTo: new Date(new Date().getFullYear(), new Date().getMonth(), lastDayOfThisMonth),
			},
		},
		{
			id: "thisYear",
			value: {
				plantDateFrom: new Date(new Date().getFullYear(), 0, 1),
				plantDateTo: new Date(new Date().getFullYear(), 11, 31),
			},
		},
		{
			id: "lastWeek",
			value: {
				plantDateFrom: new Date(lastWeek.setDate(new Date().getDate() - new Date().getDay() - 7)),
				plantDateTo: new Date(lastWeek.setDate(new Date().getDate() - new Date().getDay() - 1)),
			},
		},
		{
			id: "lastMonth",
			value: {
				plantDateFrom: new Date(yearOfLastMonth, new Date().getMonth() - 1, 1),
				plantDateTo: new Date(yearOfLastMonth, new Date().getMonth() - 1, lastDayOfLastMonth),
			},
		},
		{
			id: "lastYear",
			value: {
				plantDateFrom: new Date(new Date().getFullYear() - 1, 0, 1),
				plantDateTo: new Date(new Date().getFullYear() - 1, 11, 31),
			},
		},
		{
			id: "custom",
			value: {
				plantDateFrom: timeRangeStart,
				plantDateTo: timeRangeEnd,
			},
		},
		{
			id: "allDates",
			value: {
				plantDateFrom: new Date(2001, 0, 1),
				plantDateTo: new Date(2099, 0, 1),
			},
		},
	];
	// #endregion

	// #region Filter Update Callback Functions

	//-- Protocol Specific Updates
	const updateProtocolName = useCallback(
		(val) => {
			setProtocolName(val);
		},
		[protocolName],
	);

	const updateProtocolOwner = useCallback(
		(val) => {
			setProtocolOwner(val);
		},
		[protocolOwner],
	);

	//-- Trial Specific Updates
	const updateTrialName = useCallback(
		(val) => {
			setTrialName(val);
		},
		[trialName],
	);

	const updateTrialOwner = useCallback(
		(val) => {
			setTrialOwner(val);
		},
		[trialOwner],
	);

	const updateCooperator = useCallback(
		(val) => {
			setCooperator(val);
		},
		[cooperator],
	);

	const updateCity = useCallback(
		(val) => {
			setCity(val);
		},
		[city],
	);

	const updateRegion = useCallback(
		(val) => {
			setRegion(val);
		},
		[region],
	);

	const updateCountry = useCallback(
		(val) => {
			setCountry(val);
		},
		[country],
	);

	const updateCompany = useCallback(
		(val) => {
			setCompany(val);
		},
		[company],
	);

	const updateDEFStatus = useCallback(
		(val) => {
			setDefStatus(val);
		},
		[defStatus],
	);

	// #endregion

	///////////////////
	// CORE BEHAVIOR //
	///////////////////

	// 1. When the page first loads, populate the time range presets.
	useEffect(() => {
		setTimeRangePresetOptions();
		getGrowingSeasons();
	}, []);

	// 2. Once the time range presets have been configured, attempt to load the API data.
	useEffect(() => {
		if (timeRanges?.length > 0) {
			loadPageModeAppropriateData();
		}
	}, [timeRanges]);

	// 3. When the queries have finished running, link the trials to the protocols.
	useEffect(() => {
		if (!unlinkedTrialDataLoading && !unlinkedProtocolDataLoading) {
			if (unlinkedTrialData && unlinkedProtocolData) {
				linkTrialsAndProtocols();
			}
		}
	}, [unlinkedTrialData, unlinkedProtocolData]);

	// 4. Once the trials have been linked to the protocols, apply our filters.
	useEffect(() => {
		if (!linkingTrialsLoading && !linkingProtocolsLoading) {
			if (linkedTrialData && linkedProtocolData) {
				applyFilters();
			}
		}
	}, [linkedTrialData, linkedProtocolData]);

	// 5. Once the trial data has been filtered, update the map to show the trial pins.
	useEffect(() => {
		if (filteredTrialData.length > 0) {
			let trialsWithCoordinates = _.filter(filteredTrialData, (ftd) => {
				return (
					ftd.urLat != 0 &&
					ftd.urLat !== null &&
					ftd.urLat !== undefined &&
					ftd.urLong != 0 &&
					ftd.urLong !== null &&
					ftd.urLong !== undefined &&
					ftd.llLat != 0 &&
					ftd.llLat !== null &&
					ftd.llLat !== undefined &&
					ftd.llLong != 0 &&
					ftd.llLong !== null &&
					ftd.llLong !== undefined
				);
			});

			var mappedTrialPinData = _.map(trialsWithCoordinates, (t) => {
				return {
					name: t.trialName,
					trialId: t.trialId,
					llLat: t.llLat,
					llLong: t.llLong,
					urLat: t.urLat,
					urLong: t.urLong,
				};
			});

			updateMapboxTrials(mappedTrialPinData);
		}
	}, [filteredTrialData]);

	/////////////////////////
	// CORE IMPLEMENTATION //
	/////////////////////////

	// Set the available time range preset options in the dropdown.
	const setTimeRangePresetOptions = () => {
		let options = [
			{
				key: "noDate",
				value: "noDate",
				text: "No Plant Date",
			},
			{
				key: "thisWeek",
				value: "thisWeek",
				text: "This Week",
			},
			{
				key: "thisMonth",
				value: "thisMonth",
				text: "This Month",
			},
			{
				key: "thisYear",
				value: "thisYear",
				text: "This Year",
			},
			{
				key: "lastWeek",
				value: "lastWeek",
				text: "Last Week",
			},
			{
				key: "lastMonth",
				value: "lastMonth",
				text: "Last Month",
			},
			{
				key: "lastYear",
				value: "lastYear",
				text: "Last Year",
			},
			{
				key: "custom",
				value: "custom",
				text: "Custom",
			},
			{
				key: "allDates",
				value: "allDates",
				text: "All Dates",
			},
		];

		setTimeRanges(options);
	};

	const getGrowingSeasons = async () => {
		const accessToken = await getTokenSilently();
		dispatch(growingSeasonActions.getGrowingSeasonDetails(accessToken, clientId))
			.then((res) => {
				if (res.statusCode === 200) {
					setGrowingSeasons(res.data);
				} else {
					toast.error("Unable to load Growing Season data. Please try again.");
				}
			})
			.catch((err) => {
				console.error(err);
				toast.error("Unable to load Growing Season data. Please try again.");
			});
	};

	// Load the appropriate data based on the current mode.
	const loadPageModeAppropriateData = (manualRefresh) => {
		if (mode === "all") {
			getTrialAndProtocolDataForAllMode(manualRefresh);
		} else if (mode === "favorites") {
			getTrialAndProtocolDataForFavoritesMode(manualRefresh);
		} else if (mode === "updated") {
			getTrialAndProtocolDataForUpdatedMode(manualRefresh);
		} else if (mode === "published") {
			getTrialAndProtocolDataForPublishedMode(manualRefresh);
		}
	};

	// Load data for the 'All' page mode.
	const getTrialAndProtocolDataForAllMode = async (manualRefresh) => {
		const accessToken = await getTokenSilently();

		let customTimeRangeObject = {
			plantDateFrom: "Mon Jan 01 2001",
			plantDateTo: "Thu Jan 01 2099",
		};

		if (timeRangeStart !== null) {
			customTimeRangeObject.plantDateFrom = new Date(timeRangeStart).toDateString();
		}
		if (timeRangeEnd !== null) {
			customTimeRangeObject.plantDateTo = new Date(timeRangeEnd).toDateString();
		}

		if (timeRangeStart === null || timeRangeEnd === null) {
			// TRIAL DATA
			setUnlinkedTrialDataLoading(true);
			dispatch(trialActions.searchForTrials(customTimeRangeObject, userAuth.currentClientId, false, accessToken))
				.then((res) => {
					setUnlinkedTrialDataLoading(false);
					setupGrowingSeasonOptions(res.growingSeasons);
					setUnlinkedTrialData(
						_.filter(res.trialInfos, (ti) => {
							return ti.plantDate === null;
						}),
					);
					setTrialStatuses(res.trialStatuses);
				})
				.catch((err) => {
					toast.error("Error searching for trials. Please try again.");
					console.error(err);
				});
		} else {
			let specifiedTimeRangeObject = {};
			//Get the current year growing season options and dates to refresh the data properly when someone clicks the "clear filters" button
			if (manualRefresh) {
				let currentGrowingSeason = getCurrentGrowingSeason();
				let currentGsExists = _.find(growingSeasonOptions, (gso) => gso.value.includes(currentGrowingSeason));
				let gsMatch = currentGsExists
					? _.find(growingSeasons, (gs) => gs.name.includes(currentGrowingSeason))
					: _.find(growingSeasons, (gs) =>
							gs.name.includes(_.find(growingSeasonOptions, (gso) => gso.value !== "all")?.text),
						);
				if (gsMatch) {
					let timeStart = new Date(gsMatch?.startYear, 0, 1);
					let timeEnd = new Date(gsMatch?.endYear, 11, 31);
					specifiedTimeRangeObject = { plantDateFrom: timeStart.toDateString(), plantDateTo: timeEnd.toDateString() };
					let optMatch = _.find(growingSeasonOptions, (gs) => gs.text.includes(gsMatch.name));
					setGrowingSeason(optMatch.value);

					if (!currentGsExists) {
						setTimeRangeStart(timeStart);
						setTimeRangeEnd(timeEnd);
					}
				}
			} else {
				specifiedTimeRangeObject = getSpecifiedTimeRange();
			}

			// TRIAL DATA
			setUnlinkedTrialDataLoading(true);
			dispatch(trialActions.searchForTrials(specifiedTimeRangeObject, userAuth.currentClientId, false, accessToken))
				.then((res) => {
					setUnlinkedTrialDataLoading(false);

					let trialInfo = res.trialInfos;
					setupGrowingSeasonOptions(res.growingSeasons);
					setUnlinkedTrialData(trialInfo);
					setTrialStatuses(res.trialStatuses);
				})
				.catch((err) => {
					toast.error("Error searching for trials. Please try again.");
					console.error(err);
				});
		}

		setTimeRangeDirty(false);

		// PROTOCOL DATA
		if (!unlinkedProtocolData) {
			setUnlinkedProtocolDataLoading(true);
			dispatch(protocolActions.getProtocols(userAuth.currentClientId, false, accessToken))
				.then((res) => {
					// Make sure the user has a valid license required to look at protocols.
					res.data = _.filter(res.data, (d) => {
						if (
							userAuth.hasApplicationArea(ApplicationArea.HomeOverview, d.clientId) ||
							userAuth.hasApplicationArea(ApplicationArea.HomeRecentlyPublished, d.clientId)
						) {
							return d;
						}
					});

					setUnlinkedProtocolDataLoading(false);
					setUnlinkedProtocolData(res.data);
				})
				.catch((err) => {
					toast.error("Error searching for protocols. Please try again.");
					console.error(err);
				});
		}
	};

	// Load data for the 'Favorites' page mode.
	const getTrialAndProtocolDataForFavoritesMode = async (manualRefresh) => {
		const accessToken = await getTokenSilently();

		if (manualRefresh) {
			// let currentGrowingSeason = getCurrentGrowingSeason();
			// let currentGsExists = _.find(growingSeasonOptions, (gso) => gso.value.includes(currentGrowingSeason));
			// let optMatch = currentGsExists ?? _.find(growingSeasonOptions, (gso) => gso.value !== "all");
			setGrowingSeason("all");

			// if (!currentGsExists) {
			// 	let gsMatch = _.find(growingSeasons, (gs) => gs.name.includes(optMatch.text));
			// 	setTimeRangeStart(new Date(gsMatch?.startYear, 0, 1));
			// 	setTimeRangeEnd(new Date(gsMatch?.endYear, 11, 31));
			// }
		}

		// TRIAL DATA
		setUnlinkedTrialDataLoading(true);
		dispatch(trialActions.getTrialFavorites(userAuth.currentClientId, accessToken))
			.then((res) => {
				setUnlinkedTrialDataLoading(false);
				setupGrowingSeasonOptions(res.data.growingSeasons);
				setUnlinkedTrialData(res.data.trialInfos);
				setTrialStatuses(res.data.trialStatuses);
			})
			.catch((err) => {
				toast.error("Error searching for trials. Please try again.");
				console.error(err);
			});

		setTimeRangeDirty(false);

		// PROTOCOL DATA
		if (!unlinkedProtocolData) {
			setUnlinkedProtocolDataLoading(true);
			dispatch(protocolActions.getProtocolFavorites(userAuth.currentClientId, accessToken))
				.then((res) => {
					setUnlinkedProtocolDataLoading(false);
					setUnlinkedProtocolData(res.data);
				})
				.catch((err) => {
					toast.error("Error searching for protocols. Please try again.");
					console.error(err);
				});
		}
	};

	// Load data for the 'Updated' page mode.
	const getTrialAndProtocolDataForUpdatedMode = async (manualRefresh) => {
		const accessToken = await getTokenSilently();

		if (manualRefresh) {
			// let currentGrowingSeason = getCurrentGrowingSeason();
			// let currentGsExists = _.find(growingSeasonOptions, (gso) => gso.value.includes(currentGrowingSeason));
			// let optMatch = currentGsExists ?? _.find(growingSeasonOptions, (gso) => gso.value !== "all");
			setGrowingSeason("all");

			// if (!currentGsExists) {
			// 	let gsMatch = _.find(growingSeasons, (gs) => gs.name.includes(optMatch.text));
			// 	setTimeRangeStart(new Date(gsMatch?.startYear, 0, 1));
			// 	setTimeRangeEnd(new Date(gsMatch?.endYear, 11, 31));
			// }
		}

		// TRIAL DATA
		setUnlinkedTrialDataLoading(true);
		dispatch(trialActions.getRecentlyUpdatedTrials(userAuth.currentClientId, accessToken))
			.then((res) => {
				setUnlinkedTrialDataLoading(false);
				setupGrowingSeasonOptions(res.data.growingSeasons);
				setUnlinkedTrialData(res.data.trialInfos);
				setTrialStatuses(res.data.trialStatuses);
			})
			.catch((err) => {
				toast.error("Error searching for trials. Please try again.");
				console.error(err);
			});

		setTimeRangeDirty(false);

		// PROTOCOL DATA
		if (!unlinkedProtocolData) {
			setUnlinkedProtocolDataLoading(true);
			dispatch(protocolActions.getRecentlyUpdatedProtocols(userAuth.currentClientId, accessToken))
				.then((res) => {
					setUnlinkedProtocolDataLoading(false);
					setUnlinkedProtocolData(res.data);
				})
				.catch((err) => {
					toast.error("Error searching for protocols. Please try again.");
					console.error(err);
				});
		}
	};

	// Load data for the 'Published' page mode.
	const getTrialAndProtocolDataForPublishedMode = async (manualRefresh) => {
		const accessToken = await getTokenSilently();

		if (manualRefresh) {
			// let currentGrowingSeason = getCurrentGrowingSeason();
			// let currentGsExists = _.find(growingSeasonOptions, (gso) => gso.value.includes(currentGrowingSeason));
			// let optMatch = currentGsExists ?? _.find(growingSeasonOptions, (gso) => gso.value !== "all");
			setGrowingSeason("all");

			// if (!currentGsExists) {
			// 	let gsMatch = _.find(growingSeasons, (gs) => gs.name.includes(optMatch.text));
			// 	setTimeRangeStart(new Date(gsMatch?.startYear, 0, 1));
			// 	setTimeRangeEnd(new Date(gsMatch?.endYear, 11, 31));
			// }
		}

		// TRIAL DATA
		setUnlinkedTrialDataLoading(true);
		dispatch(trialActions.getRecentlyPublishedTrials(userAuth.currentClientId, accessToken))
			.then((res) => {
				setUnlinkedTrialDataLoading(false);
				setupGrowingSeasonOptions(res.data.growingSeasons);
				setUnlinkedTrialData(res.data.trialInfos);
				setTrialStatuses(res.data.trialStatuses);
			})
			.catch((err) => {
				toast.error("Error searching for trials. Please try again.");
				console.error(err);
			});

		setTimeRangeDirty(false);

		// PROTOCOL DATA
		if (!unlinkedProtocolData) {
			setUnlinkedProtocolDataLoading(true);
			dispatch(protocolActions.getProtocols(userAuth.currentClientId, false, accessToken))
				.then((res) => {
					// Make sure the user has a valid license required to look at protocols.
					res.data = _.filter(res.data, (d) => {
						if (
							userAuth.hasApplicationArea(ApplicationArea.HomeOverview, d.clientId) ||
							userAuth.hasApplicationArea(ApplicationArea.HomeRecentlyPublished, d.clientId)
						) {
							return d;
						}
					});
					setUnlinkedProtocolDataLoading(false);
					setUnlinkedProtocolData(res.data);
				})
				.catch((err) => {
					toast.error("Error searching for protocols. Please try again.");
					console.error(err);
				});
		}
	};

	// Based on the date filters and selected time preset option, get the times that the user is trying to query for.
	const getSpecifiedTimeRange = () => {
		let specifiedTimeRange =
			timeRangeStart && timeRangeEnd
				? { plantDateFrom: timeRangeStart.toDateString(), plantDateTo: timeRangeEnd.toDateString() }
				: {
						plantDateFrom: _.find(timeRangePresetLookup, {
							id: selectedTimeRange,
						})?.value.plantDateFrom.toDateString(),
						plantDateTo: _.find(timeRangePresetLookup, { id: selectedTimeRange })?.value.plantDateTo.toDateString(),
					};
		/*
			Returns an object in the form:
			{
				plantDateFrom: ...
				plantDateTo: ...
			}
		*/
		return specifiedTimeRange;
	};

	// Attempt to associate each of the trials with a protocol name that they are associated with.
	const linkTrialsAndProtocols = () => {
		setLinkingTrialsLoading(true);
		setLinkingProtcolsLoading(true);
		let tempTrialData = _.cloneDeep(unlinkedTrialData);
		let tempProtocolData = _.cloneDeep(unlinkedProtocolData);

		// Assign a set of protocol names each of the matched trials.
		_.map(tempProtocolData, (p) => {
			_.map(p.trialIds, (tId) => {
				// Find the full trial object with the current trial Id.
				let matchingTrial = _.find(tempTrialData, { trialId: tId });

				// If we find a trial, append the protocol name to the trials 'protocolNames' list.
				if (matchingTrial) {
					matchingTrial.protocolNames = matchingTrial.protocolNames
						? [...matchingTrial.protocolNames, p.protocolName]
						: [p.protocolName];
				}
			});
		});

		// Additionally, remove protocols which cannot be linked for certain page modes.
		if (mode === "published") {
			// Get a list of the trialIds that we have.
			var targetTrialIds = _.map(tempProtocolData, (p) => {
				return _.map(p.trialIds, (tId) => {
					return tId;
				});
			});

			var uniqueTrialIds = targetTrialIds.flat().filter((value, index, self) => {
				return self.indexOf(value) === index;
			});

			var linkedProtocols = _.filter(tempProtocolData, (p) => {
				var protocolRelevant = p.trialIds.some((tId) => {
					return uniqueTrialIds.includes(tId);
				});
				return protocolRelevant;
			});

			setLinkedTrialData(tempTrialData);
			setLinkingTrialsLoading(false);

			setLinkedProtocolData(linkedProtocols);
			setLinkingProtcolsLoading(false);
		} else {
			setLinkedTrialData(tempTrialData);
			setLinkingTrialsLoading(false);

			setLinkedProtocolData(tempProtocolData);
			setLinkingProtcolsLoading(false);
		}
	};

	// Apply all of the filter fields on the page to the retrieved data.
	const applyFilters = (reset = false, requestData = null) => {
		let filteredResults = filterResults(
			reset,
			requestData,
			linkedProtocolData,
			linkedTrialData,
			crop,
			growingSeason,
			variableTested,
			protocolName,
			protocolOwner,
			trialName,
			trialOwner,
			cooperator,
			city,
			region,
			country,
			company,
			defStatus,
			mode,
			selectedTimeRange,
			trialStatuses,
		);

		// If we are on the recently updated or published pages, we need to take the top X records after applying the filters.
		if (mode === "updated" || mode === "published") {
			const numberOfRecentTrialsToDisplay = 10;
			const numberOfRecentProtocolsToDisplay = 10;

			if (filteredResults.filteredProtocolData !== null) {
				filteredResults.filteredProtocolData = filteredResults.filteredProtocolData.slice(
					0,
					numberOfRecentProtocolsToDisplay,
				);
			}
			if (filteredResults.filteredTrialData !== null) {
				filteredResults.filteredTrialData = filteredResults.filteredTrialData.slice(0, numberOfRecentTrialsToDisplay);
			}
		}

		filteredResults.filteredProtocolData = _.orderBy(
			filteredResults.filteredProtocolData,
			["growingSeasonName", "protocolName"],
			["desc"],
		);
		filteredResults.filteredTrialData = _.orderBy(
			filteredResults.filteredTrialData,
			["growingSeasonName", "companyName", "trialName"],
			["desc"],
		);

		setFilteredProtocolData(filteredResults.filteredProtocolData);
		setFilteredTrialData(filteredResults.filteredTrialData);

		setTrialFilterLoading(false);
		setProtocolFilterLoading(false);
	};

	const getCurrentGrowingSeason = () => {
		//const date = new Date();

		//let month = date.getMonth() + 1;
		let year = "2026"; //date.getFullYear();

		let season = "Spring";
		//if (month < 5 || month > 12) season = "Fall";

		return `${year} ${season}`;
	};

	useEffect(() => {
		if (growingSeasonOptions?.length > 0 && growingSeasons?.length > 0) {
			let gsMatch = _.filter(growingSeasons, (gs) => {
				return gs.name === growingSeason;
			});

			if (growingSeason === "all" && selectedTimeRange === "allDates") {
				setTimeRangeStart(new Date(2001, 0, 1));
				setTimeRangeEnd(new Date(2099, 0, 11));
			} else if (gsMatch.length > 0) {
				setTimeRangeStart(new Date(gsMatch[0].startYear, 0, 1));
				setTimeRangeEnd(new Date(gsMatch[0].endYear, 11, 31));
			}
		}
	}, [growingSeasonOptions, growingSeasons]);

	const setupGrowingSeasonOptions = (opts) => {
		if (!growingSeason && growingSeasonOptions?.length === 0) {
			let currentGrowingSeason = getCurrentGrowingSeason();

			let gsOptions = _.map(opts, (o) => {
				return { value: o.name, text: o.name };
			});

			let currentGsExists = _.find(gsOptions, (gs) => gs.value.includes(currentGrowingSeason));
			let currentGrowingSeasonSelection = currentGsExists?.value ?? gsOptions[0]?.value;

			gsOptions.unshift({ value: "all", text: "All" });

			if (mode !== "all") {
				setSelectedTimeRange("allDates");
			} else if (!currentGsExists) {
				setSelectedTimeRange("custom");
			} else {
				setSelectedTimeRange("thisYear");
			}

			setGrowingSeason(mode !== "all" ? "all" : currentGrowingSeasonSelection);
			setGrowingSeasonOptions(gsOptions);
		}
	};

	//////////////
	// HANDLERS //
	//////////////

	// When the selected time preset changes, change the contents of the "Time Range Start" and "Time Range End" fields.
	useEffect(() => {
		// If the user selects anything other than the "None" option, attempt to set the start and end fields to the correct date.
		if (selectedTimeRange !== "none" && selectedTimeRange) {
			setTimeRangeStart(_.find(timeRangePresetLookup, { id: selectedTimeRange })?.value.plantDateFrom);
			setTimeRangeEnd(_.find(timeRangePresetLookup, { id: selectedTimeRange })?.value.plantDateTo);
			setTimeRangeDirty(true);
		}
	}, [selectedTimeRange]);

	// When the user clicks the reset button, clear all of the filter fields.
	const handleResetFields = () => {
		//-- Triggers reset useEffects in child components
		setResetFields(!resetFields);
		setCrop("All");
		setVariableTested("All");

		let currentGs = getCurrentGrowingSeason();
		let timeRange = _.find(growingSeasonOptions, (gso) => gso.value.includes(currentGs)) ? "thisYear" : "custom";
		setSelectedTimeRange(mode !== "all" ? "allDates" : timeRange);

		handleFilterSearch(true);
	};

	// When the user clicks the apply button, we need to re-query for data (because the time fields affect which data we've retrieved).
	const handleFilterSearch = (manualRefresh = null) => {
		setProtocolFilterLoading(true);
		setTrialFilterLoading(true);

		if (timeRangeDirty || manualRefresh) {
			loadPageModeAppropriateData(manualRefresh);
		} else {
			applyFilters();
		}
	};

	return (
		<>
			<Segment className="dashboardForm" basic>
				<Form>
					<Grid>
						<Grid.Row>
							{/* <Grid.Column width="2">
							<Form.Input
								fluid
								label="Product Category"
								placeholder="Product Category"
								type="text"
								value={productCategory ?? ""}
								onChange={(event, { value }) => {
									setProductCategory(value);
								}}
							/>
						</Grid.Column> */}
							{/*Top Left Filters*/}
							<Grid.Column width={5}>
								<Grid>
									<Grid.Row style={{ justifyContent: "space-between" }}>
										<Form.Dropdown
											fluid
											label="Crop"
											openOnFocus
											onChange={(event, { value }) => {
												setCrop(value);
											}}
											onSearchChange={(event, { searchQuery }) => {
												setCrop(searchQuery);
											}}
											options={[
												{ text: "All", value: "All" },
												..._.uniqBy(
													_.map(unlinkedTrialData, (t) => {
														return { text: t.cropName, value: t.cropName };
													}).concat(
														_.map(unlinkedProtocolData, (p) => {
															return { text: p.cropName, value: p.cropName };
														}),
													),
													"value",
												).sort((a, b) => (a.value > b.value ? 1 : -1)),
											]}
											placeholder="Crop"
											search
											searchQuery={crop ?? ""}
											selection
											selectOnBlur={false}
											type="text"
											value={crop ?? ""}
											disabled={trialFilterLoading || protocolFilterLoading}
											onOpen={() => setCrop("")}
										/>

										<Form.Dropdown
											fluid
											label="Variable Tested"
											openOnFocus
											onChange={(event, { value }) => {
												setVariableTested(value);
											}}
											onSearchChange={(event, { searchQuery }) => {
												setVariableTested(searchQuery);
											}}
											options={[
												{ text: "All", value: "All" },
												..._.uniqBy(
													_.map(unlinkedProtocolData, (p) => {
														return _.map(p.protocolVariables, (pv) => {
															return { text: pv.name, value: pv.name };
														});
													}).flat(),
													"value",
												).sort((a, b) => (a.value > b.value ? 1 : -1)),
											]}
											placeholder="Variable Tested"
											search
											searchQuery={variableTested ?? ""}
											selection
											selectOnBlur={false}
											type="text"
											value={variableTested ?? ""}
											disabled={trialFilterLoading || protocolFilterLoading}
											onOpen={() => setVariableTested("")}
										/>
									</Grid.Row>
									<Grid.Row style={{ justifyContent: "space-between" }}>
										<Form.Dropdown
											fluid
											label="Growing Season"
											openOnFocus
											onChange={(event, { value }) => {
												setGrowingSeason(value);
												if (value === "all") {
													setTimeRangeStart(new Date(2001, 0, 1));
													setTimeRangeEnd(new Date(2099, 0, 1));
												} else {
													let gsMatch = _.filter(growingSeasons, (gs) => {
														return gs.name === value;
													});
													setTimeRangeStart(new Date(gsMatch[0].startYear, 0, 1));
													setTimeRangeEnd(new Date(gsMatch[0].endYear, 11, 31));
												}
												setSelectedTimeRange("custom");
											}}
											onSearchChange={(event, { searchQuery }) => {
												setGrowingSeason(searchQuery);
											}}
											options={growingSeasonOptions}
											placeholder="Growing Season"
											search
											//searchQuery={growingSeason ?? ""}
											selection
											selectOnBlur={false}
											type="text"
											value={growingSeason ?? ""}
											disabled={trialFilterLoading || protocolFilterLoading}
										/>

										<Form.Select
											fluid
											label="Presets"
											disabled={(mode !== "all" && mode !== "favorites") || trialFilterLoading || protocolFilterLoading}
											search
											options={timeRanges}
											value={selectedTimeRange}
											onChange={(event, { value }) => {
												setSelectedTimeRange(value);
												setGrowingSeason("all");
											}}
											// style={{
											// 	backgroundColor: mode !== "all" ? "#EEEEEE" : "#FFFFFF"
											// }}
										/>
									</Grid.Row>
									<Grid.Row style={{ justifyContent: "space-between" }}>
										<Form.Field
											label={"Plant Range Start"}
											control={DateTimePicker}
											disabled={(mode !== "all" && mode !== "favorites") || trialFilterLoading || protocolFilterLoading}
											includeTime={false}
											value={timeRangeStart}
											onChange={(date) => {
												setSelectedTimeRange("custom");
												setTimeRangeDirty(true);
												if (date) {
													setTimeRangeStart(date);
												} else {
													setTimeRangeStart(null);
												}
												setGrowingSeason("all");
											}}
										/>

										<Form.Field
											label={"Plant Range End"}
											control={DateTimePicker}
											disabled={(mode !== "all" && mode !== "favorites") || trialFilterLoading || protocolFilterLoading}
											value={timeRangeEnd}
											onChange={(date) => {
												setSelectedTimeRange("custom");
												setTimeRangeDirty(true);
												if (date) {
													setTimeRangeEnd(date);
												} else {
													setTimeRangeEnd(null);
												}
												setGrowingSeason("all");
											}}
										/>
									</Grid.Row>
									<Grid.Row style={{ justifyContent: "flex-end", gap: 8 }}>
										<Button
											negative
											onClick={() => handleResetFields()}
											disabled={trialFilterLoading || protocolFilterLoading}
											loading={trialFilterLoading || protocolFilterLoading}
										>
											Reset
										</Button>
										<Button
											primary
											onClick={() => handleFilterSearch()}
											disabled={trialFilterLoading || protocolFilterLoading}
											loading={trialFilterLoading || protocolFilterLoading}
										>
											Filter
										</Button>
									</Grid.Row>

									{/*End Top Middle Filters*/}
								</Grid>
							</Grid.Column>
							<Grid.Column width={11} style={{ paddingRight: 0 }}>
								{children}
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Form>
			</Segment>

			<ProtocolSearch
				unfilteredProtocolList={unlinkedProtocolData}
				filteredProtocolList={filteredProtocolData}
				setProtocolName={(val) => updateProtocolName(val)}
				setProtocolOwner={(val) => updateProtocolOwner(val)}
				loading={protocolFilterLoading}
				reset={resetFields}
			/>

			<TrialSearch
				unfilteredTrialList={unlinkedTrialData}
				filteredTrialList={filteredTrialData}
				trialStatuses={trialStatuses}
				setTrialName={(val) => updateTrialName(val)}
				setTrialOwner={(val) => updateTrialOwner(val)}
				setCooperator={(val) => updateCooperator(val)}
				setCity={(val) => updateCity(val)}
				setRegion={(val) => updateRegion(val)}
				setCountry={(val) => updateCountry(val)}
				setCompany={(val) => updateCompany(val)}
				setDefStatus={(val) => updateDEFStatus(val)}
				loading={trialFilterLoading}
				reset={resetFields}
			/>
		</>
	);
};

Dashboard.propTypes = {
	mode: PropTypes.string.isRequired,
	updateMapboxTrials: PropTypes.func,
	children: PropTypes.node,
};

export default Dashboard;
